<template>
  <div
    class="bg-shade-50 border-black transition-shadow duration-200 transform-gpu"
    :class="shadowConfig[elevation][shadow]"
  >
    <slot></slot>
  </div>
</template>
<script lang="ts" setup>
import { PropType } from 'vue'

const props = defineProps({
  shadow: {
    type: String as PropType<ShadowVisibility>,
    default: 'hover',
  },
  elevation: {
    type: String as PropType<ShadowElevation>,
    default: 'md',
  },
})

const shadowConfig: Record<
  ShadowElevation,
  Record<ShadowVisibility, string>
> = {
  sm: {
    hover: 'border hover:shadow-sm focus:shadow-sm',
    always: 'border shadow-sm',
    never: 'border ',
  },
  md: {
    hover: 'border-2 hover:shadow-md focus:shadow-md',
    always: 'border-2 shadow-md',
    never: 'border-2 ',
  },
  lg: {
    hover: 'border-2 hover:shadow-lg focus:shadow-lg',
    always: 'border-2 shadow-lg',
    never: 'border-2 ',
  },
}
</script>
